// src/modules/strategies.ts
// 按 ProfileCode 挑选学习策略,组合策略放在最前面(更具情景化、对偏好用户更醒目)
import strategiesRaw from '../data/strategies.json';
import type { Dim, ProfileCode, StrategiesData } from '../types/index.js';

const strategies = strategiesRaw as unknown as StrategiesData;

const PER_DIM_LIMIT = 3;

/**
 * 取该 code 的学习策略列表。组合策略前置,后接每维度前 N 条。
 * @param code VARK 类型 code
 * @param limit 截断条数。不传返回全部。
 */
export function pickStrategies(code: ProfileCode, limit?: number): string[] {
  const perDim = [...code].flatMap((d) => {
    const arr = strategies[d as Dim];
    return arr ? arr.slice(0, PER_DIM_LIMIT) : [];
  });
  const combo = code.length >= 2 ? strategies.combinations?.[code] ?? [] : [];
  const list = [...combo, ...perDim];
  return typeof limit === 'number' ? list.slice(0, limit) : list;
}
